import React from "react";
import { Star } from "lucide-react";

const TestimonialsSection = () => {
  const testimonials = [
    {
      name: "Priya Sharma",
      role: "Parent",
      text: '"My child now loves coding and AI. The mentors are excellent and the platform is very engaging. Highly recommend Practido!"',
      avatar: "https://api.dicebear.com/7.x/adventurer/svg?seed=Priya",
      avatarBg: "#ffedd5",
      delay: "delay-100"
    },
    {
      name: "Arjun Patel",
      role: "Student, Class 9",
      text: '"Practido made learning future skills fun. I built my own game and AI chatbot in just 3 months!"',
      avatar: "https://api.dicebear.com/7.x/adventurer/svg?seed=Arjun",
      avatarBg: "#dcfce7",
      delay: "delay-200"
    },
    {
      name: "Meera Reddy",
      role: "Parent",
      text: '"Excellent mentors and project-based teaching. My daughter is now so confident in her coding skills."',
      avatar: "https://api.dicebear.com/7.x/adventurer/svg?seed=Meera",
      avatarBg: "#f3e8ff",
      delay: "delay-300"
    },
    {
      name: "Rahul Kumar",
      role: "Student, Class 11",
      text: '"The AI and Robotics course is amazing. I learned so much and even participated in national competitions!"',
      avatar: "https://api.dicebear.com/7.x/adventurer/svg?seed=Rahul",
      avatarBg: "#e0f2fe",
      delay: "delay-100"
    },
    {
      name: "Anjali Singh",
      role: "Parent",
      text: '"Best investment in my child\'s future. The curriculum is well-structured and the live classes are interactive."',
      avatar: "https://api.dicebear.com/7.x/adventurer/svg?seed=Anjali",
      avatarBg: "#fee2e2",
      delay: "delay-200"
    },
    {
      name: "Vikram Mehta",
      role: "Student, Class 7",
      text: '"I love the gamified learning approach. Earning badges and competing on leaderboards makes learning exciting!"',
      avatar: "https://api.dicebear.com/7.x/adventurer/svg?seed=Vikram",
      avatarBg: "#fef9c3",
      delay: "delay-300"
    }
  ];

  return (
    <section className="section testimonials section-white" id="testimonials">
      <div className="container">
        <div className="section-header reveal-triggered fade-up active">
          <h2 style={{ color: "var(--text-primary)", fontWeight: 800 }}>What Students and Parents Say <span style={{ color: "#6366f1" }}>About Practido</span></h2>
          <p>Thousands of students are already developing future-ready skills through project-based learning and innovation programs.</p>
        </div>

        <div className="testimonials-grid">
          {testimonials.map((test, index) => (
            <div key={index} className={`premium-card testimonial-card reveal-triggered fade-up ${test.delay} active`}>
              <div className="testimonial-header">
                <div className="testimonial-avatar" style={{ backgroundColor: test.avatarBg }}>
                  <img src={test.avatar} alt={`${test.name} - student or parent review at Practido`} loading="lazy" />
                </div>
                <div className="testimonial-info">
                  <h4>{test.name}</h4>
                  <p>{test.role}</p>
                </div>
              </div>
              <div className="testimonial-stars">
                {Array.from({ length: 5 }).map((_, i) => (
                  <Star key={i} size={16} fill="#fbbf24" stroke="#fbbf24" strokeWidth={2} />
                ))}
              </div>
              <p className="testimonial-text">{test.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
